












































































import { Component, Prop, Watch } from 'vue-property-decorator';
import Draggable from 'vuedraggable';

import CommonVue from '../../models/commonVue';
import { BusEvent } from '@/models/bus';
import LockManager from '@/models/lock';

import ApiList from '@/api/list';

import EditIcon from '@/components/icons/EditIcon.vue';
import ArrowIcon from '@/components/icons/ArrowIcon.vue';
import DownIcon from '@/components/icons/DownIcon.vue';
import RightIcon from '@/components/icons/RightIcon.vue';
import ModulesIcon from '@/components/icons/ModulesIcon.vue';
import SkillsIcon from '@/components/icons/SkillsIcon.vue';
import TopicsIcon from '@/components/icons/TopicsIcon.vue';
import CategoriesIcon from '@/components/icons/CategoriesIcon.vue';
import ProgramIcon from '@/components/icons/TopicsIcon.vue';
import reject from 'lodash/reject';
import Module from '@/api/module';
import Project from '@/api/project';
import { InternationalizedField } from '@/api/common';
import { includes } from 'lodash';

interface NamedEntity {
  SLUG: string;
  id: number;
  order: number;
  name: InternationalizedField<string>;
  is_program?: boolean;
  save();
}

@Component({
  components: {
    draggable: Draggable,
    'edit-icon': EditIcon,
    'arrow-icon': ArrowIcon,
    'down-icon': DownIcon,
    'right-icon': RightIcon,
    'modules-icon': ModulesIcon,
    'skills-icon': SkillsIcon,
    'topics-icon': TopicsIcon,
    'categories-icon': CategoriesIcon,
    'programs-icon': ProgramIcon
  }
})
export default class ListProject extends CommonVue {
  @Prop({ type: Number }) public id?: number;
  @Prop({ type: String }) public entity!: string;
  @Prop() public list!: Promise<ApiList<NamedEntity>>;
  @Prop() public projects!: Promise<ApiList<Project>>;
  @Prop({ type: Boolean, default: false }) public isEdit!: boolean;

  public loadedList: ApiList<NamedEntity> | null = null;
  public projectList: ApiList<Project> | null = null;

  public projectDragOptions: object = {
    group: 'project',
    ghostClass: 'ghost'
  };
  public entityDragOptions: object = {
    group: 'entity',
    ghostClass: 'ghost'
  };
  public draggedElement: NamedEntity = null;
  public projectDraggedElement: Project = null;
  public moving: boolean = false;

  public selectedProjectId = null;
  public selectedProjectArray = [];

  // used to prevent scrolling when clicking on the list
  public ignoreUpdate: boolean = false;

  public async beforeMount() {
    this.busy = true;
    await this.loadList();
    this.busy = false;
  }

  @Watch('list')
  public async loadList() {
    this.busy = true;
    try {
      this.loadedList = await this.list;
      this.projectList = await this.projects;

      if (this.entity === Module.SLUG) {
        this.loadedList.results = reject(this.loadedList.results, (item) => {
          return item.is_program;
        });
      }
    } catch (e) {
      this.error = true;
      this.$bus.$emit(BusEvent.ERROR, 'Could not load list', e);
    } finally {
      this.busy = false;
    }
  }

  public updated() {
    if (!this.ignoreUpdate) {
      this.scrollToElement();
      this.ignoreUpdate = true;
    }
  }

  public scrollToElement() {
    if (
      this.$refs.scrollElement &&
      (this.$refs.scrollElement as any[]).length === 1
    ) {
      this.$refs.scrollElement[0].scrollIntoView();
    }
  }

  public lineClicked(id: number) {
    this.$router.push(`/${this.MODULE_SLUG}/${id}`);
  }

  public checkItemInArray(id) {
    return this.selectedProjectArray.includes(id);
  }

  public projecCollapsable(id: number) {
    const index = this.selectedProjectArray.indexOf(id);
    if (index > -1) {
        this.selectedProjectArray.splice(index, 1);
    } else {
      this.selectedProjectArray.push(id);
    }
  }
  
  public projectItemClicked(id: number) {
    this.$router.push(`/${this.PROJECT_SLUG}/${id}/`);
  }

  public editClicked(id: number, e) {
    e.stopPropagation();
    this.$router.push(`/${this.MODULE_SLUG}/${id}`);
  }
}
